import { render } from "./FeedbackUploadScreen.vue?vue&type=template&id=83d7a5a8"
import script from "./FeedbackUploadScreen.vue?vue&type=script&lang=ts"
export * from "./FeedbackUploadScreen.vue?vue&type=script&lang=ts"

import "./FeedbackUploadScreen.vue?vue&type=style&index=0&id=83d7a5a8&lang=scss"
script.render = render

export default script